import React from 'react';
import { Box, BoxProps, withStyles } from '@material-ui/core';
import { centerBoxProps } from 'globals/utils';
import SendInvitationSrc from 'assets/images/invite-new-customer/send-invititation.svg';
import RegisterSrc from 'assets/images/invite-new-customer/register.svg';
import ReceiveReportSrc from 'assets/images/invite-new-customer/receive-report.svg';
import FsBody from 'ui-elements/typography/FsBody';
import { purple } from 'globals/colors';

export const WrapperBox = withStyles(() => ({
  root: {
    width: '100%',
    '&:hover i': {
      transform: `scale(1.2)`,
    },
  },
}))(Box);

export type IconBoxIconType = 'invite' | 'register' | 'receive-report';

interface ImageContainerProps extends BoxProps {
  iconType?: IconBoxIconType;
}

export const ImageContainer = withStyles(({ spacing, transitions }) => ({
  root: {
    ...centerBoxProps,
    maxWidth: 150,
    height: 150,
    margin: spacing(2, 'auto'),
    backgroundImage: `url(${SendInvitationSrc})`,
    backgroundSize: `contain`,
    backgroundPosition: `50% 50%`,
    backgroundRepeat: `no-repeat`,
    transition: transitions.create(['transform']),
    '&.register': {
      backgroundImage: `url(${RegisterSrc})`,
    },
    '&.receive-report': {
      backgroundImage: `url(${ReceiveReportSrc})`,
    },
  },
}))(({ iconType, ...otherProps }: ImageContainerProps) => (
  <Box {...otherProps} className={iconType} />
));

export const Line = withStyles(({ spacing }) => ({
  root: {
    margin: spacing(2, 'auto'),
    width: 52,
    height: 4,
    borderRadius: 2,
    backgroundColor: purple.V2,
  },
}))(Box);

export const Label = withStyles(({ spacing }) => ({
  root: {
    textAlign: 'center',
    margin: spacing(0, 'auto'),
    maxWidth: 200,
  },
}))(FsBody);
